import React, { useEffect, useState } from 'react';
import { Card, Modal, Spinner, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Layout from '../../layout/default';
import Block from '../../components/Block/Block';
import { MediaGroup, Media, MediaText, Image } from "../../components";
import { toInitials } from "../../utilities";
import instance, { imageUrl } from "../api";
import DataTable from '../../components/DataTable/DataTable';

function UserListPage() {
  const [ showModal, setShowModal ] = useState(false);
  

  // NEW CODE
  const [ searchText, setSearchText ] = useState("")
  // NEW CODE ENDS



  const [selectedUser, setSelectedUser] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const handleCloseModal = () => setShowModal(false);

  const userColumns = [
    {
      name: "Users",
      grow: 2,
      selector: (row) => row.firstname,
      cell: (row) => (
        <MediaGroup>
  <Media size="md" shape="circle" className="user-pro" variant={row.theme && row.theme}>
    {row.firstname && row.lastname ? (
      row.profile_picture ? (
        <Image src={`${imageUrl}/${row.profile_picture}`} staticImage />
      ) : (
        <span className="smaller fw-medium initials-container">
          {toInitials(row.firstname)}
        </span>
      )
    ) : (
      <span className=""></span>
    )}
  </Media>
  <MediaText>
    <span 
      className="small text" 
      style={{ whiteSpace: "nowrap", cursor: 'pointer' }} 
      onClick={() => handleShowOrders(row)}
    >
      {row.firstname && row.lastname ? `${row.firstname} ${row.lastname}` : '-----'}
    </span>
    <span className="small text" style={{ whiteSpace: "nowrap" }}>
      {row.firstname && row.lastname ? row.email : ''}
    </span>
  </MediaText>
</MediaGroup>

      ),
      sortable: true,
      minWidth: "300px",
    },
    {
      name: "Contact",
      selector: (row) => row.telephone,
      cell: (row) => <span>{row.telephone}</span>,
      sortable: true,
    },
    {
      name: "Address",
      selector: (row) => row.address1,
      cell: (row) => <span>{row.address1}</span>,
      sortable: true,
    },
    {
      name: "Joined Date",
      selector: (row) => row.date_added,
      cell: (row) => (
        <span style={{ whiteSpace: "nowrap" }}>{new Date(row.date_added).toDateString()}</span>
      ),
      sortable: true,
      hide: "lg",
    },
  ];

  const getUserData = async (page, pageSize) => {
    try {
      // setLoading(true);
       const queryParams = `pageSize=${pageSize}&page=${page}` + 
        (searchText ? `&search=${searchText}` : '');
      
      const response = await instance.get(
        // `api/Customer?pageSize=${pageSize}&page=${page}`
        `api/Customer?${queryParams}`
      );

      setUsersData(response.data.rows);
      setTotalCount(response.data.count);
      

      // if (response.status === 200 && response.data?.rows) {
      //   console.log('Fetched data:', response.data.rows); // Debug log
      //   setUsersData(response.data.rows);
      //   setTotalCount(response.data.count); // Set the total count for pagination
      // } else {
      //   console.error("Unexpected response structure", response.data);
      // }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleShowOrders = async (user) => {
    setSelectedUser(user);
    setLoadingOrders(true);
    setShowModal(true);
    try {
      const response = await instance.get(`api/Order/${user.customer_id}/customer`);
      setOrders(response.data.rows);
    } catch (error) {
      console.error('Error fetching user orders:', error);
    } finally {
      setLoadingOrders(false);
    }
  };

  useEffect(() => {
    getUserData(page, rowsPerPage); // Fetch users based on the current page and rows per page
  }, [ page, rowsPerPage, searchText ]);
  
    // NEW CODE
    const handleSearchTextChange = (text) => {
    setSearchText(text);
    };
  // NEW CODE ENDS
  


  const handleChangePage = (_event, newPage) => {
    // console.log('Changing page to:', newPage); // Debug log
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newSize = parseInt(event.target.value, 10);
    // console.log('Changing rows per page to:', newSize); // Debug log
    setRowsPerPage(newSize);
    setPage(0);
  };

  return (
    <Layout title="Users List" content="container">
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">Users List</Block.Title>
            {/* <nav>
              <ol className="breadcrumb breadcrumb-arrow mb-0">
                <li className="breadcrumb-item"><Link to="/home-ecommerce">Home</Link></li>
                <li className="breadcrumb-item"><Link to="/user-manage/user-list">User Manage</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Users</li>
              </ol>
            </nav> */}
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>
      {loading ? (
        <div className="text-center my-4">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Block>
          <Card>
            <DataTable
              tableClassName="data-table-head-light table-responsive"
              data={usersData}
              columns={userColumns}
              searchList={['firstname', 'lastname', 'telephone']}
              searchTerm="First Name or Telephone"
              totalCount={totalCount}
              page={page}
              rowsPerPage={rowsPerPage}
              onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                // NEW ONE 
            onSearchTextChange={handleSearchTextChange}
            // NEW ONE ENDS
            />
          </Card>
        </Block>
      )}

      <Modal show={showModal} onHide={handleCloseModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{selectedUser ? `${selectedUser.firstname} ${selectedUser.lastname}'s Orders` : 'User Orders'}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          {loadingOrders ? (
            <div className="text-center my-4">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : orders.length > 0 ? (
            <Table responsive>
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Product Name (Quantity)</th>
                  <th>Total</th>
                  <th>Date Ordered</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((order) => (
                  <tr key={order.order_id}>
                    <td>{order.order_id}</td>
                    <td>
                      {order.WebtagOrderProducts.map((product) => `${product.name}(${product.quantity})`).join(', ')}
                    </td>
                    <td>{order.total}</td>
                    <td>{new Date(order.date_added).toDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <p>No orders found for this user.</p>
          )}
        </Modal.Body>
      </Modal>
    </Layout>
  );
}

export default UserListPage;
